import React from 'react';
import { LocalizationsProvider } from './src-hooks-useLocalizations.js';
import { getLocalizationsFor } from './src-localization-getLocalizations.js';
import { useProductStore } from './src-store-productPriceDetails.store.js';
import CSRWrapper from './src-components-CSRWrapper-index.js';
import PriceErrorBoundary from './src-components-PriceErrorBoundary.js';
import { PriceExtractionWrapper } from './src-components-PriceExtraction-PriceExtractionWrapper.js';

const PriceDisplay = (props) => {
  const basePriceExtractionConfig = useProductStore((state) => state.basePriceExtractionConfig);
  const { locale = "" } = basePriceExtractionConfig || {};
  const localizations = getLocalizationsFor(locale);
  return (
    // CSRWrapper added to avoid hydration error glitches for SSR rendered pages
    /* @__PURE__ */ React.createElement(CSRWrapper, null, /* @__PURE__ */ React.createElement(LocalizationsProvider, { localizations }, /* @__PURE__ */ React.createElement(PriceErrorBoundary, { fallbackUi: /* @__PURE__ */ React.createElement(React.Fragment, null) }, /* @__PURE__ */ React.createElement(
      PriceExtractionWrapper,
      {
        ...props,
        requestedDisplayStrategy: props.priceDisplayStrategy
      }
    ))))
  );
};

export { PriceDisplay as default };
//# sourceMappingURL=src-components-PriceDisplay-PriceDisplay.js.map
